import { Box, Card, CardContent, Grid, Typography, useTheme, IconButton } from "@mui/material";
import { getMarketPlaces } from "../../../redux/actions/marketplacesActions";
import { getEcommercePlaces } from "../../../redux/actions/ecommercePlaceActions";
import { fetchPlacesCategory } from "../../../redux/actions/placesCategoryActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const PlatformCard = ({ platforms, title, selectedPlatform, onPlatformSelect, setMarketPlaceName }) => {
    const theme = useTheme();

    return (
        <Card sx={{ mb: 4, boxShadow: 3, borderRadius: 2 }}>
            <CardContent>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    Lütfen aşağıdan ilgili platformu seçin.
                </Typography>
                <Grid container spacing={2}>
                    {platforms.map((platform) => {
                        const isSelected = selectedPlatform === platform.id;
                        return (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={platform.id}>
                                <Card
                                    onClick={() => {
                                        onPlatformSelect(platform.id);
                                        setMarketPlaceName(platform.name);
                                    }}
                                    sx={{
                                        cursor: 'pointer',
                                        boxShadow: isSelected ? `0 0 0 2px ${platform.colorCode}` : 1,
                                        borderRadius: 2,
                                        transition: 'all 0.3s ease',
                                        position: 'relative',
                                        '&:hover': {
                                            boxShadow: 4,
                                        },
                                        p: 1
                                    }}
                                >
                                    {isSelected && (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: theme.spacing(1),
                                                right: theme.spacing(1),
                                                color: platform.colorCode
                                            }}
                                        >
                                            <CheckCircleIcon />
                                        </Box>
                                    )}
                                    <CardContent
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            textAlign: 'center'
                                        }}
                                    >
                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                color: isSelected ? platform.colorCode : 'text.primary',
                                                fontWeight: isSelected ? 'bold' : 'normal'
                                            }}
                                        >
                                            {platform.name}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </CardContent>
        </Card>
    );
};

const SelectMarketpace = ({
    selectedPlatformType,
    setSelectedPlatformType,
    selectedPlatform,
    setSelectedPlatform,
    setMarketPlaceName,
    selectedProducts,
    setSelectedPlacesCategory
}) => {
    const token = useSelector(state => state?.auth?.user?.accessToken?.token);
    const dispatch = useDispatch();
    const theme = useTheme();
    const [marketplaces, setMarketplaces] = useState([]);
    const [ecommerce, setEcommerce] = useState([]);

    const handlePlatformTypeSelect = (type) => {
        setSelectedPlatformType(type);
        setSelectedPlatform(null);
    };

    const handlePlatformSelect = (platformId) => {
        setSelectedPlatform(platformId);
    };

    const getMarketPlace = async () => {
        try {
            const response = await dispatch(getMarketPlaces(token));
            if (response.success) {
                setMarketplaces(response?.data);
            }
        } catch (err) {
            console.log("Marketler getirilemedi", err);
        }
    };

    const getEcommercePlace = async (token) => {
        try {
            const response = await dispatch(getEcommercePlaces(token));
            if (response.success) {
                setEcommerce(response?.data);
            }
        } catch (err) {
            console.log("Marketler getirilemedi", err);
        }
    };

    const getPlaceCategory = async () => {
        try {
            const queryModel = {};
            queryModel.categoryId = selectedProducts[0]?.categoryId;
            if (!selectedPlatformType) {
                return;
            }
            if (selectedPlatformType === "ecommerce") {
                queryModel.ecommercePlaceId = selectedPlatform;
            } else {
                queryModel.marketPlaceId = selectedPlatform;
            }
            const response = await dispatch(fetchPlacesCategory(queryModel));
            setSelectedPlacesCategory(response?.data[0]);
        } catch (error) {
            console.error("Error fetching products:", error);
        }
    };

    useEffect(() => {
        getMarketPlace();
        getEcommercePlace();
    }, []);

    useEffect(() => {
        getPlaceCategory();
    }, [selectedPlatform]);

    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
                Platform Türünü Seçin
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Lütfen önce pazaryeri veya e-ticaret platform tipini seçip ardından ilgili platformu seçiniz.
            </Typography>

            <Grid container spacing={4} sx={{ mb: 4 }}>
                <Grid item xs={12} sm={6}>
                    <Card
                        onClick={() => handlePlatformTypeSelect('marketplace')}
                        sx={{
                            cursor: 'pointer',
                            borderRadius: 2,
                            boxShadow: selectedPlatformType === 'marketplace' ? `0 0 0 3px ${theme.palette.primary.main}` : 1,
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                boxShadow: 4
                            },
                            p: 2,
                            textAlign: 'center'
                        }}
                    >
                        <StorefrontIcon sx={{ fontSize: 40, mb: 1, color: theme.palette.primary.main }} />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Pazaryerleri
                        </Typography>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Card
                        onClick={() => handlePlatformTypeSelect('ecommerce')}
                        sx={{
                            cursor: 'pointer',
                            borderRadius: 2,
                            boxShadow: selectedPlatformType === 'ecommerce' ? `0 0 0 3px ${theme.palette.primary.main}` : 1,
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                boxShadow: 4
                            },
                            p: 2,
                            textAlign: 'center'
                        }}
                    >
                        <ShoppingCartIcon sx={{ fontSize: 40, mb: 1, color: theme.palette.primary.main }} />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            E-Ticaret
                        </Typography>
                    </Card>
                </Grid>
            </Grid>

            {selectedPlatformType === 'marketplace' && (
                <PlatformCard
                    platforms={marketplaces}
                    title="Pazaryeri Seçin"
                    selectedPlatform={selectedPlatform}
                    onPlatformSelect={handlePlatformSelect}
                    setMarketPlaceName={setMarketPlaceName}
                />
            )}

            {selectedPlatformType === 'ecommerce' && (
                <PlatformCard
                    platforms={ecommerce}
                    title="E-Ticaret Platformlarını Seçin"
                    selectedPlatform={selectedPlatform}
                    onPlatformSelect={handlePlatformSelect}
                    setMarketPlaceName={setMarketPlaceName}
                />
            )}
        </Box>
    );
};

export default SelectMarketpace;
